<template>
  <generic-update-list
    v-bind="{ model, modelHeaders, modelFk, defaultItem }"
    custom-export-url="/show-instruments/export/"
    has-availabilities
    has-availability-place
  >
    <template v-slot:form="{ editedItem, error }">
      <v-row>
        <v-col cols="12" sm="4">
          <autocomplete
            v-model="editedItem.instrument"
            :error-messages="error.instrument"
            :items-filter="(item) => item.is_rentable"
            :model="instrumentModel"
            item-text="name"
            item-value="id"
            label="Strumento"
          ></autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="editedItem.status"
            :error-messages="error.status"
            :items="[
              { value: 1, text: 'selezionato' },
              { value: 2, text: 'contattato' },
              { value: 3, text: 'approvato' },
            ]"
            label="Stato"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.code"
            :error-messages="error.code"
            label="Codice"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.company"
            :error-messages="error.company"
            label="Azienda"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.contact"
            :error-messages="error.contact"
            label="Contatto"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.price"
            :error-messages="error.price"
            label="Prezzo"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <ul v-if="editedItem.warnings && editedItem.warnings.length > 0">
        <li
          v-for="warning in editedItem.warnings"
          :key="warning"
          class="red--text"
        >
          <template
            v-if="warning.type == 'outside_instrument_availability_range'"
          >
            L'evento associato {{ warning.event_name }} è all'infuori del range
            di disponibilità
          </template>
        </li>
      </ul>
    </template>

    <template v-slot:item.status="{ item }">
      <status-indicator small :status="item.status" />
    </template>

    <template v-slot:item.export="{ item }">
      <router-link
        :to="{
          name: 'ExportInstrument',
          params: { id: modelFk.show, instrumentId: item.id },
        }"
      >
        Esporta
      </router-link>
    </template>

    <template v-slot:item.warnings="{ item }">
      <v-icon v-if="item.warnings.length > 0">
        fa fa-exclamation-triangle
      </v-icon>
    </template>
  </generic-update-list>
</template>

<script>
import models from "@/models"
import statuses from "@/statuses"

export default {
  data() {
    return {
      modelHeaders: [
        { text: "Strumento", value: "instrument__name" },
        { text: "Stato", value: "status" },
        { text: "Esporta", value: "export" },
        { text: "Alert", value: "warnings" },
      ],
      model: models.ShowInstrument,
      instrumentModel: models.Instrument,
      statuses,
    }
  },
  computed: {
    modelFk() {
      return { show: this.$route.params.id }
    },
  },
  methods: {
    defaultItem: () => ({
      availabilities: [],
      instrument: null,
      code: "",
      company: "",
      contact: "",
      price: 0,
    }),
  },
}
</script>
